<template>
          <Tables ref="tableAnnouncements"
              :columns="columns"
              :showSearch="false"
              style="font-family:'Segoe UI'"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              v-on:Load="onLoad"
              :key="keyTableAnnouncements"
            >
              <tr v-for="announce in arrayAnnouncements" v-bind:key="announce.id" >
                <TableColumn :IsText="true"   v-on:Edit="Edit(announce)" :status="1" :value="announce.titulo"  />
                <TableColumn :IsText="true"   v-on:Edit="Edit(announce)" :status="1" :value="['ZCorretor', 'Zincorporações Morador'][announce.aplicativo]"/>
                <TableColumn :IsText="true"   v-on:Edit="Edit(announce)" :status="1" :value="announce.nomeEmpreendimento"/>
                <TableColumn :IsText="true"   v-on:Edit="Edit(announce)" :status="1" :value="announce.dataAcaoFormatada" />
                <TableColumn :IsText="true"   v-on:Edit="Edit(announce)" :status="1" :value="announce.inquilino.nome" />
                <TableColumn :IsActionsButtons="true" :IsDocumentActions="true" v-on:Edit="Edit(announce)" :HasDelete="false" v-on:Delete="Delete(announce.id)" :status="1"
                :HasChange="false" :HasDetails="false" v-on:Download="onDownloadIncome(announce.id)" :HasDownload="announce.existeArquivo"/>
              </tr>
            </Tables>
</template>

<script>
import tableAnnouncements from './tableAnnouncements'
export default tableAnnouncements

</script>

<style scoped>
  .table_data{
    font: normal normal normal 15px/20px Segoe UI;
    color: #656565;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/announcements/components/tableAnnouncements/tableAnnouncements.vue